import { Select } from "@eisox/design-system";

import { getFrostFreeStatusLabel, type FrostFreeMode } from "~/features/frost-free/helpers/frost-free.helper";
import { m } from "~/paraglide/messages";

interface FrostFreeSelectProps<T extends FrostFreeMode> {
  modes: readonly T[];
  value?: NoInfer<T>;
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
}

const FrostFreeSelect = <T extends FrostFreeMode>({
  modes,
  value,
  onChange,
  disabled,
  className,
}: FrostFreeSelectProps<T>) => (
  <Select.Root multiple={false} value={value} onValueChange={onChange as (value: string) => void}>
    <Select.Trigger disabled={disabled} className={className}>
      <Select.Value placeholder={m.choose_mode()} />
    </Select.Trigger>
    <Select.Content>
      <Select.Viewport>
        {modes.map(mode => (
          <Select.Item key={mode} value={mode}>
            {getFrostFreeStatusLabel(mode)}
          </Select.Item>
        ))}
      </Select.Viewport>
    </Select.Content>
  </Select.Root>
);

export { FrostFreeSelect };
export type { FrostFreeSelectProps };
